export default [
  {
    name: 'bestellnummer',
    titel: 'Fahrzeugnummer',
  },
  {
    name: 'hersteller',
    titel: 'Hersteller',
  },
  {
    name: 'modell',
    titel: 'Modell',
  },
  {
    name: 'gebrauchtyp_fzgtool',
    titel: 'Typ',
  },
  {
    name: 'herstellerfarbe_fzgtool',
    titel: 'Farbe',
  },
  {
    name: 'ausstattungslinie_fzgtool',
    titel: 'Version',
  },

  {
    name: 'wwwpreis',
    titel: 'Hauspreis',
  },

  {
    name: 'leistungkw',
    titel: 'Leistung KW',
  },
  {
    name: 'kraftstoff',
    titel: 'Kraftstoff',
  },
  {
    name: 'batteriekapazitaet',
    titel: 'Batterie-<br>kapazität',
    suffix: ' kWh',
  },
  {
    name: 'fahrgestellnr',
    titel: 'Fahrgestellnummer',
  },
  {
    name: 'kilometerstand',
    titel: 'Kilometerstand',
  },
  {
    name: 'erstzulassung_fzgtool',
    titel: 'Erstzulassung',
  },
  {
    name: 'standort',
    titel: 'Standort',
  },
];
